// Times and money in the team screens: always UTC and 24 hours, so a text does not depend on the browser's time zone (and a test does not
// depend on the clock of the machine).

const pad = (value: number): string => String(value).padStart(2, "0");

/** `2026-10-17 09:30 UTC` */
export function utcText(iso: string): string {
  const time = new Date(iso);
  return `${time.getUTCFullYear()}-${pad(time.getUTCMonth() + 1)}-${pad(time.getUTCDate())} ${pad(time.getUTCHours())}:${pad(time.getUTCMinutes())} UTC`;
}

export const utcOrOpen = (iso: string | null): string =>
  iso === null ? "no end date" : utcText(iso);

/** `datetime-local` input value (`2026-10-17T09:30`) read as UTC and turned into an ISO instant. */
export function utcInputToIso(value: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
  const time = new Date(`${value}:00.000Z`);
  return Number.isNaN(time.getTime()) ? null : time.toISOString();
}

/** The `datetime-local` value of an instant, in UTC, for a default. */
export function isoToUtcInput(iso: string): string {
  return iso.slice(0, 16);
}

/** `INR 125,000.00` from paise (money is an integer in paise; no float arithmetic on it). */
export function paiseText(amountMinor: number, currency: string): string {
  const sign = amountMinor < 0 ? "-" : "";
  const absolute = Math.abs(amountMinor);
  const whole = Math.trunc(absolute / 100)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${sign}${currency} ${whole}.${pad(absolute % 100)}`;
}
